<template>
  <div class="container-fluid px-0">
    <div class="nut-banner">
      <div class="container">
        <div class="banner-child">
        </div>
        <h1>Secretele <br class="d-block d-md-none">laptelui matern <br class="d-none d-md-block">
          și beneficiile lui pentru imunitate.
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
}
</script>

<style scoped lang="scss">
.nut-banner {
  height: 460px;
  background-image: url("../../assets/images/image-secretele-laptelui/secrete-lapte.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  .container {
    height: inherit;
    position: relative;

    .banner-child:after {

    }

    h1 {
      bottom: 40px;
      position: absolute;
      line-height: 46px;
      font-weight: 700;
      width: 100%;
      color: white;
      text-align: center;
      font-size: 44px;
      margin-bottom: 30px;

      p {
        font-family: 'Montserrat', sans-serif;
        font-size: 20px;
        font-weight: 400;
        line-height: 27px;
      }
    }

    .arrow-right {
      position: absolute;
      right: 93px;
      top: 15px;
      z-index: 15;
    }
  }
}

@media screen and (max-width: 992px) {

}

@media screen and (max-width: 768px) {
  .nut-banner {
    height: 460px;

    .container {
      padding: 0;
      margin: 0;
      max-width: 100%;

      h1 {
        font-size: 30px;
        line-height: 34px;
        padding-left: 30px;
      }

      p {
        font-size: 18px;
      }

      .banner-child {
        background: url("../../assets/images/image-secretele-laptelui/mama-800.png");
        height: 460px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: left;

        &:after {
          content: "";
        }
      }

    }
  }
}

@media screen and (max-width: 450px) {
  .nut-banner {
    height: 415px;

    .container {
      padding: 0;
      margin: 0;
      max-width: 100%;

      h1 {
        font-size: 30px;
        line-height: 34px;
        padding-left: 15px;
        margin-bottom: -10px;
      }

      p {
        font-size: 18px;
      }

      .banner-child {
        background: url("../../assets/images/image-secretele-laptelui/mama-450.png");
        height: 415px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: left;

        &:after {
          content: "";
        }

        h1 {
          font-size: 30px;
        }
      }

    }
  }
}

</style>
